<template>
  <svg class="parkos-mark" :width="size" :height="size" viewBox="0 0 32 32" aria-hidden="true" focusable="false">
    <rect width="32" height="32" rx="9" :fill="onDark ? '#3b82f6' : '#1e3a5f'" />
    <path d="M10 24V8h7.2a5 5 0 010 10H14" fill="none" stroke="#fff" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
    <circle v-if="!onDark" cx="23" cy="10" r="2.4" fill="#3b82f6" />
  </svg>
</template>

<script setup>
// Logo de Parkos (misma marca que el sitio y el favicon). onDark: versión para fondos oscuros.
defineProps({
  size: { type: Number, default: 28 },
  onDark: { type: Boolean, default: false },
})
</script>

<style scoped>
.parkos-mark { display: block; flex-shrink: 0; }
</style>